import { render, staticRenderFns } from "./ArticleModal.vue?vue&type=template&id=512cb294&scoped=true"
import script from "./ArticleModal.vue?vue&type=script&lang=js"
export * from "./ArticleModal.vue?vue&type=script&lang=js"
import style0 from "./ArticleModal.vue?vue&type=style&index=0&id=512cb294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512cb294",
  null
  
)

export default component.exports